import { buildFacetDesignOverride, overrideReadOnly } from 'Packages/FacetRest/FacetDesignOverride';
import { FDBodyText, FDHeadlineText, FDSwitchInput } from '@facet-wealth/design';
import RichTextField from 'Components/ComponentLibrary/Molecules/RichTextField';

const TaxStrategyMetaOverride = buildFacetDesignOverride()
  .override({ name: 'title' }, {
    _component: () => FDHeadlineText,
    _customProps: { size: 'sm', color: 'textSecondary' },
  }, overrideReadOnly)
  .override({ name: 'subtitle' }, {
    _component: () => FDBodyText,
    _customProps: { size: 'lg' },
  }, overrideReadOnly)
  .override({ type: 'bool' }, {
    _component: () => FDSwitchInput,
    _customProps: { label: '', helperText: '' },
  }, overrideReadOnly)
  .override({ name: 'additionalSettingsTitle' }, {
    _component: () => FDHeadlineText,
    _customProps: { size: 'sm', color: 'textSecondary' },
  }, overrideReadOnly)
  .override({ hint: 'multiline' }, { _customProps: { rows: 10, maxRows: 50 } }, overrideReadOnly)
  .nameOverride('content', {
    _component: () => RichTextField,
  }, overrideReadOnly);
export default TaxStrategyMetaOverride;
